import { getInventoryIssue } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRInventoryIssue = (inventoryIssueId: string | null) => {
  const {
    data: inventoryIssue,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(inventoryIssueId ? `inventoryIssue-${inventoryIssueId}` : null, () =>
    getInventoryIssue(inventoryIssueId as string)
  );

  return {
    inventoryIssue,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRInventoryIssue;
